import { useState } from "react";
import { PageTitle, SectionSelector, SmsGatewayStatus } from "../../components";
import CreateGroups from "./CreateGroups";
import History from "./History";
import "./NotificationsPage.scss";
import ScheduleAMessage from "./ScheduleAMessage";
import ScheduledMessages from "./ScheduledMessages";
import SentMessages from "./SentMessages";

function NotificationsPage() {
  const [activeSection, setActiveSection] = useState(0);
  // const confirm = useConfirm();
  const sections = [
    SentMessages,
    ScheduleAMessage,
    ScheduledMessages,
    CreateGroups,
    History,
  ];

  const ActiveSectionComponent = sections[activeSection];

  return (
    <div className="page notifications-page">
      <div className="page notifications-page-section">
        <div className="page-title-section">
          <PageTitle text="Notification Center" />
          <SmsGatewayStatus />
        </div>
      </div>
      <div className="page notifications-page-section">
        <div className="notifications-nav">
          <SectionSelector
            currentSection={activeSection}
            sectionList={[
              { text: "Send Messages" },
              { text: "Schedule a New Message" },
              { text: "Schedule Messages" },
              { text: "Create Groups" },
              { text: "History" },
            ]}
            onSectionChange={setActiveSection}
          />
        </div>
        <ActiveSectionComponent />
      </div>
    </div>
  );
}

export default NotificationsPage;
